var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"04c813bb0f0e9ddfab6f6aeedcde15cf09cb0cdc"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["halayalla-website@halayalla"]={id:"04c813bb0f0e9ddfab6f6aeedcde15cf09cb0cdc"};
      